import { Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { convertToMoney } from '@woovi/utils';

import type { PaymentMethodBoletoPixValue_charge$key } from './__generated__/PaymentMethodBoletoPixValue_charge.graphql.ts';

type PaymentMethodBoletoPixValueProps = {
  charge: PaymentMethodBoletoPixValue_charge$key;
};

const PaymentMethodBoletoPixValue = (
  props: PaymentMethodBoletoPixValueProps,
): ReactNode => {
  const { t } = useTranslation();

  const charge = useFragment<PaymentMethodBoletoPixValue_charge$key>(
    graphql`
      fragment PaymentMethodBoletoPixValue_charge on Charge {
        company {
          nameFriendly
        }
        value
      }
    `,
    props.charge,
  );

  return (
    <Typography variant='h5' fontWeight='bold' textAlign='center'>
      {t('Pay {{value}} to {{companyName}} via Boleto or Pix', {
        value: convertToMoney(charge.value),
        companyName: charge?.company?.nameFriendly,
      })}
    </Typography>
  );
};

export default PaymentMethodBoletoPixValue;
